// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--f313f";
export var accordion__item = "Accordion-module--accordion__item--b4c55";
export var accordion__item__content = "Accordion-module--accordion__item__content--a04f3";
export var accordion__item__isOpen = "Accordion-module--accordion__item__isOpen--d5471";
export var accordion__item__title = "Accordion-module--accordion__item__title--9c235";
export var beautiful = "Accordion-module--beautiful--b095e";
export var close = "Accordion-module--close--029a8";
export var tabView = "Accordion-module--tabView--bd9dc";
export var toggle = "Accordion-module--toggle--c74b3";